/**
 * @fileoverview Entry point for theinertia js.
 */

require('./affix');
require('lazysizes');

module.exports = {
  $: require('jquery'),
  ads: require('./ads'),
  pages: require('./pages')
};
